import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import IconKey from "../../component/SvgIcons/IconKey";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api";
import "../UsersList/index.css";

export default function AddUsers() {
  const navigate = useNavigate();
  const alert = useSwal();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedMode, setSelectedMode] = useState('');
  
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    contact: "",
    address: "",
    type: "", 
    status: "",   
  });
  const handleRadioChange = (userstatus) => {
    setSelectedMode(userstatus.target.value);
  };
  
  const handleContactChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    const contactRegex = /^[6-9][0-9]{9}$/; // 10 digits starting with 6-9

    if (value.length > 10) {
      return; // Prevent more than 10 digits
    }
    setFormData((prev) => ({
      ...prev,
      contact: value,
    }));
    setError(
      !contactRegex.test(value)
        ? "Contact number must be 10 digits and start with 6-9."
        : ""
    );
  };

  //#handlesubmmit
const handleSubmit = async (e) => {
  e.preventDefault();

  if (error) {
    alert("error", "Please fix the errors before submitting");    
    return;
  }

  if (!selectedMode) {
    alert("error", "Please select a user status (Active or Deactive).");    
    return;
  }

  setLoading(true);
  try {      
    const payload = {
      ...formData,
      status: selectedMode === "Active" ? 1 : 0,
    };

    const response = await api.post("/insertUser", payload);

    if (response.data.error) {
      // ✅ Show backend validation error in alert
      alert("error", response.data.error);
      return;
    }

    alert("success", response.data.message);
    navigate("/users-list");           
  } catch (err) {
    console.error("Error inserting user record:", err);
    if (err.response && err.response.data.error) {
      alert("error", err.response.data.error); // 👈 also shows duplicate email error here
    } else {
      alert("error", "Failed to create user record.");  
    }
  } finally {
    setLoading(false);
  }
};

  //#endregion

  //#region handle input
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};
  //#endregion handle input

  return (
    <section className="dashboardpage">
      <Header pageTitle="Add Users Details"  backTo="/users-list" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-start col-xl-6 col-12">
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container">
               <div className="input-container">
              <select
                name="type"
                className="form-select"
                style={{ width: "100%" }}
                value={formData.type}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>Select User Type</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
              </select>
              </div>

              <div className="input-container">
                <input
                  type="text"
                  name="username"  // ✅ uses name
                  placeholder="Enter User Name"
                  value={formData.username}
                  onChange={handleInputChange}
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"  // ✅ changed to name
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />             
                <span className="underline"></span>
                <span className="icon-key" onClick={() => setShowPassword(!showPassword)}>
                  <IconKey /> 
                </span>
              </div>

              <div className="input-container">
                <input
                  type="email"
                  name="email"  // ✅ changed to name
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="input-container">
                {error && (
                  <ins className="error-text" style={{ color:"var(--RedColor)" }}>
                    {error}
                  </ins>
                )}
                <input
                  type="text"
                  name="contact"  // ✅ changed to name
                  placeholder="Enter Contact"
                  value={formData.contact}
                  onChange={handleContactChange}
                  maxLength="10"  // ✅ removed manual length check (this is enough)
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="input-container">
                <input
                  type="text"
                  name="address"  // ✅ changed to name
                  placeholder="Enter Address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="radio-container">
                <span className="radio-label">Select User Status</span>
                <div className="radio-container button">
                  <label className={`radio-option ${selectedMode === 'Active' ? 'active' : ''}`}>
                    <input 
                      type="radio" 
                      name="status"   // ✅ clearer than "confirm"
                      value="Active" 
                      onChange={handleRadioChange} 
                      checked={selectedMode === 'Active'} 
                      required 
                    /> Active
                  </label>
                  <label className={`radio-option ${selectedMode === 'Deactive' ? 'active' : ''}`}>
                    <input 
                      type="radio"  
                      name="status"   // ✅ clearer
                      value="Deactive" 
                      onChange={handleRadioChange} 
                      checked={selectedMode === 'Deactive'} 
                      required 
                    /> Deactive
                  </label>
                </div>
              </div>

              <button className="btn btn-purpal" type="submit" disabled={loading}>                
                {loading ? "Submit..." : "Submit"}
              </button>               
            </div>
          </form>

        </div>
      </div>
    </section>
  );
}
